(function($){
    $('[data-product-line]').each(function(i, el) {
        var $pl = $(el);
        $pl.find('.flexslider').flexslider({
            animationSpeed: 300,
            slideshow: false,
            controlNav: false,
            fadeFirstSlide: false,
            after: function(slider) {
                console.log(slider);
                var productId = $(slider.slides[slider.currentSlide]).data('productId');
                highlightProduct(productId);
            }
        });

        $pl.find('.productv').on('mouseenter', function(event) {
            //highlightProduct($(this).data('productId'));

            var flexslider = $(this).closest('.product').find('.flexslider');
            var index = flexslider.find('[data-product-id=' + $(this).data('productId') + ']').index();

            flexslider.data('flexslider').vars.animationSpeed = 30;
            flexslider.flexslider(index);
            flexslider.data('flexslider').vars.animationSpeed = 200;
        });

        var highlightProduct = function(productId) {
            var $pv = $('.productv[data-product-id=' + productId + ']');
            $pl.find('.productv').removeClass('hover');
            $pv.addClass('hover');
        }

    });
})(jQuery);